import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, Output, ViewChild, ViewEncapsulation, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NHATestDirective } from '../../directives/test/test.directive';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';

@Component({
	selector: 'nha-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.scss'],
	encapsulation: ViewEncapsulation.None,
	exportAs: 'nhaPopup',
	imports: [CdkOverlayOrigin, NHATestDirective, CdkConnectedOverlay, CommonModule]
})
export class NHAPopupComponent {
	private _cdRef = inject(ChangeDetectorRef);

	private _isOverPopup: boolean = false;
	private _isOverTarget: boolean = false;

	@ViewChild('popupOrigin', { read: ElementRef }) private _popupOrigin: ElementRef<HTMLElement>;

	@Input() isClick: boolean = false;
	@Input() isDarkBG: boolean = false;
	@Input() offsetX: number = 0;
	@Input() offsetY: number = 0;
	@Input() contentClass: string;
	@Input() hasScrollbar: boolean = false;
	@Input() hideDelay: number = 500;
	@Input() popupHeight: string;

	@Output() openChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input() isOpen: boolean = false;

	clicked(): void {
		if (!this.isClick) {
			return;
		}
		this.isOpen = !this.isOpen;
		this.openChanged.emit(this.isOpen);

		if (!this.isOpen) {
			this.closed.emit(true);
		}
	}

	backdropClicked(): void {
		this.isOpen = false;
		this.openChanged.emit(false);
		this.closed.emit(true);
		this._cdRef.detectChanges();
		this._popupOrigin?.nativeElement?.focus();
	}

	mousedOver(): void {
		if (this.isClick) {
			return;
		}

		this._isOverPopup = false;
		this._isOverTarget = true;
		this.isOpen = true;
		this.openChanged.emit(true);
	}

	mousedOut(): void {
		if (this.isClick) {
			return;
		}

		this._isOverTarget = false;
		if (this.hideDelay === 0) {
			this.closeOnMouseOut();
		} else {
			setTimeout(this.closeOnMouseOut.bind(this), this.hideDelay);
		}
	}

	popupMousedOver(): void {
		this._isOverTarget = false;
		this._isOverPopup = true;
	}

	popupMousedOut(): void {
		this._isOverPopup = false;

		if (this.isClick) {
			return;
		}

		if (this.hideDelay === 0) {
			this.closeOnMouseOut();
		} else {
			setTimeout(this.closeOnMouseOut.bind(this), this.hideDelay);
		}
	}

	closeOnMouseOut(): void {
		if (!this._isOverPopup && !this._isOverTarget) {
			this.close();
			this._cdRef.markForCheck();
		}
	}

	@HostListener('mousewheel', ['$event'])
	scroll(_: Event): void {
		this.mousedOut();
	}

	close(): void {
		if (this.isOpen) {
			this.isOpen = false;
			this.openChanged.emit(this.isOpen);
			this.closed.emit(true);
		}
	}
}
